import React from 'react';
import { array, number } from 'prop-types';
import { isEmpty } from 'lodash';
import Feature from '../Feature';

const FeatureList = ({ features = [], packageId }) => {
    if (isEmpty(features)) {return null;}

    return (
        <ul className="features">
            {
                features.map(({ id, ...rest }) => (
                    <Feature key={id} id={id} packageId={packageId} {...rest}/>
                ))
            }
        </ul>
    );
};

FeatureList.propTypes = {
    features: array,
    packageId: number
};

export default FeatureList;
